@let showImageOnMobile = data.showImageOnMobile;
@let showText = data.text && data.text.length > 0;
<section class="pt-2">
  <div [class.bg-gray-light]="data.background === 'gray'" class="mask-curve-top pb-14 pt-7 desk:pb-20 desk:pt-14">
    <div class="centered-fullwidth">
      <div class="grid grid-cols-1 items-center gap-x-[35px] desk:grid-cols-2">
        <div class="px-5 desk:px-0">
          @if (data.title; as title) {
            <app-title [title]="title" size="h2" />
          }
          @if (showText) {
            <div [innerHtml]="data.text" class="prose prose-custom-marker py-5 leading-tight" handleHtmlLinks></div>
          }
          @if (data.cta; as cta) {
            @let gtm = data.gtmConfigCta;
            <app-button
              (onButtonClick)="
                emitGtmEvent({
                  event: gtm?.event,
                  group: gtm?.group,
                  description: gtm?.description,
                  context: gtm?.context,
                  button_text_value: cta.label,
                  event_type: 'click',
                })
              "
              [class.justify-center]="!showImageOnMobile"
              [class.pb-0]="!showText"
              [class.pt-5]="!showText"
              [label]="cta.label"
              [url]="cta.url"
              class="flex" />
          }
          @if (data.pictos && data.pictos.length > 0) {
            @let pictos_1 = data.pictos[0];
            @let pictos_2 = data.pictos[1];
            <div class="flex justify-center pt-10 desk:justify-start">
              @if (pictos_1) {
                <div class="rotate-[-7deg]">
                  <app-svg [inline]="true" [src]="pictos_1.svg" [width]="136" />
                </div>
              }
              @if (pictos_2) {
                <div class="-mt-2.5 rotate-[7.5deg]">
                  <app-svg [inline]="true" [src]="pictos_2.svg" [width]="133" />
                </div>
              }
            </div>
          }
        </div>
        <div
          [class.block]="showImageOnMobile"
          [class.hidden]="!showImageOnMobile"
          class="pl-5 pt-5 desk:block desk:p-0">
          @if (data.image; as image) {
            <div class="mask-blob-cut-ratio-0_926 desk:mask-blob-ratio-1_278 size-full">
              <app-image
                [image]="image"
                [isPriority]="!isImageInPreviousBlocks"
                [pregenerationSize]="{ width: 1280 }" />
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</section>
